<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nr5Tkh/tc-custom/9781683352679.jpg?1726454432859" alt="This image is the cover for the book Verdigris Deep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Verdigris Deep
      </h1>
      <p class="bookDescription body article font2">
        <b>“Deliciously shiver-inducing . . . Fans of dark fantasies such as Neil Gaiman’s <i>Coraline</i> will find this tale irresistible”—from the award-winning author (<i>School Library Journal</i>).</b><br/><br/>Verdigris (<i>n</i>.): a blue-green rust that tarnishes aging and forgotten copper coins, altering them entirely . . .<br/><br/>Ryan feels invisible: At school, he’s in a class with students older and cooler than him, and at home, he’s largely ignored during his parents’ petty arguments. And then he meets Josh. Josh is popular in the way that only beautiful boys can be—he’s almost electric. Both Ryan and his chatterbox sidekick, Chelle, fall under Josh’s spell, and the three soon become inseparable.<br/><br/>One summer afternoon, they sneak off to the troubled town of Magwhite. Trapped without bus fare for the ride home, Josh convinces his less mischievous companions their only solution is to steal coins from the infamous wishing well. Soon after, each develops a unique, sinister power. When the well witch appears, she gargles demands of her three new servants. Ryan, Josh, and Chelle have robbed her and now must obey her . . . and the wishes rotting at the bottom of her well.<br/><br/><b>“A deliciously creepy tale . . . There is a vividness and energy to Hardinge’s imagination that makes almost every moment of this absorbing story shine with light or glossy darkness.” —<i>The Horn Book </i>(starred review)</b><br/><br/><b>“Inescapably chilling . . . a dark, polished gem.” —<i>Publishers Weekly</i> (starred review)</b><br/><br/><b>“There’s no denying Hardinge’s power as a storyteller, her ability to create beautiful, precise imagery, or her expectation that her readers will grasp the subtle ideas and reflections woven into the novel.” —<i>Booklist</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Hardinge
      </h2>
      
      <p class="authorDescription body article">Frances Hardinge is the winner of the 2015 Costa Book of the Year for The Lie Tree, one of just two young adult novels to win this major UK literary prize. She is the author of several books for children, including Cuckoo Song, Fly by Night, and A Face Like Glass. She lives in England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47de00a0